"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
require("./styles.scss");
const SelectedServicesList = ({ htmlId, selectedServices, removeOption, lightBg }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const bgColor = lightBg ? 'rgb(207, 237, 237)' : 'rgba(255, 255, 255, 0.6)';
    return ((0, jsx_runtime_1.jsxs)("ul", Object.assign({ className: "selected-options", id: `${htmlId}-selected` }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ id: `${htmlId}-remove`, style: { display: "none" } }, { children: t("remove") })), selectedServices.map((option, i) => {
                return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ className: "remove-option", style: { backgroundColor: bgColor, borderColor: bgColor }, type: "button", "aria-describedby": `${htmlId}-remove`, onClick: () => removeOption(i) }, { children: option.name })) }, option.id));
            })] })));
};
exports.default = SelectedServicesList;
